import { selectActiveOfferId } from './selectActiveOfferId';
import { IApplicationState } from '../../../common/types/redux';

export const selectIsOfferPreviewOpen = (state: IApplicationState) => {
  return Boolean(selectActiveOfferId(state));
};
